<template>
  <el-container>
    <el-main>
      <el-tabs v-model="activeTab" type="card" @tab-remove="removeTab" @tab-click="tabClick">
        <el-tab-pane
          v-for="(item,index) in tabsItem"
          :key="item.name"
          :label="item.title"
          :name="item.name"
          :closable="item.closable"
          :ref="item.ref"
        >
          <component :is="item.content" mode="out-in" v-bind:idata="apartmentData" v-bind:sonTabsItem="sonTabsItem" v-if="(item.id==1||item.id==apartmentData.apartmentId)"></component>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import Vue from "vue";
import deviceApartmentList from "./deviceApartmentList.vue";
import deviceApartmentDetail from "./deviceApartmentDetail.vue";
export default {
  name: "deviceApartmentTabs", //公寓tab
  data() {
    return {
      activeTab: "1", //默认显示的tab
      apartmentData: "",
      tabIndex: 1, //tab目前显示数
      tabsItem: [
        {
          title: this.$t('deviceApartmentList.deviceInfo'),
          id: "1",
          name: "1",
          closable: false,
          ref: "",
          content: deviceApartmentList
        }
      ],
      tabsPath: [
        {
          name: "1",
          path: "/deviceApartmentList"
        }
      ],
      sonTabsItem:[]
    };
  },
  computed: {
    setHeight() {
      return document.documentElement.clientHeight - 65;
    },
    activeNav() {
      //当前激活的导航
      return this.$route.path;
    }
  },

  methods: {
    addDeviceApartmentDetailTab(data) {
      var oldActiveIndex = "";
      var exist = false;
      var tabData = this.tabsItem;
      this.apartmentData = data;
      for (var str in tabData) {
        if (data.apartmentId === tabData[str].id) {
          oldActiveIndex = tabData[str].name;
          exist = true;
          break;
        }
      }
      if (exist === true) {
        this.activeTab = oldActiveIndex;
        return;
      }
     
      //获得路由元数据的name和组件名
      const thisName = data.apartmentName;
      const thisComp = "deviceApartmentDetail";
      //对tabs的当前激活下标和tabs数量进行自加
      let newActiveIndex = ++this.tabIndex + "";
      this.tabsItem.push({
        title: thisName,
        id: data.apartmentId,
        name: String(newActiveIndex),
        closable: true,
        ref: data,
        content: thisComp
      });
      var sonTabsItemObj={};
      sonTabsItemObj.apartmentId=this.apartmentData.apartmentId;
      sonTabsItemObj.tabsItem=[
        {
          title: this.$t('deviceApartmentList.roomList'),
          id: "1",
          name: "1",
          closable: false,
          ref: "",
          content: "apartmentRoomList"
        }
      ],
      this.sonTabsItem.push(sonTabsItemObj);
      this.$nextTick(()=> {
          this.activeTab = newActiveIndex;
      });
    },

    removeTab(targetName) {
      //删除Tab
      let tabs = this.tabsItem; //当前显示的tab数组
      let activeName = this.activeTab; //点前活跃的tab

      //如果当前tab正活跃 被删除时执行
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
              this.tabClick(nextTab);
            }
          }
        });
      }
      this.activeTab = activeName;
      this.tabsItem = tabs.filter(tab => tab.name !== targetName);
      //在tabsPath中删除当前被删除tab的path
      this.tabsPath = this.tabsPath.filter(item => item.name !== targetName);
    },
    tabClick(thisTab, event) {
      /*
       * thisTab:当前选中的tabs的实例
       * 通过当前选中tabs的实例获得当前实例的path 重新定位路由
       * */
      let val = this.tabsItem.filter(item => thisTab.name == item.name);
      if (val[0].name == "1") {
        this.apartmentData = "";
      } else {
        this.apartmentData = val[0].ref;
        this.$store.commit("getApartmentDetail", {
          apartmentId: val[0].id
        }); //加载公寓楼栋
      }

    },
    // closeMain(val){
    //   alert(window.JSON.stringify(val));
    //   this.sonTabsItem=val;
    // }
  },
  mounted() {
    /*
     * 监听页面刷新事件
     * 页面刷新前 需要保存当前打开的tabs的位置，刷新后按刷新前的顺序展示
     * 使用js的sessionStorage保存刷新页面前的数据
     * */
    // window.addEventListener("beforeunload", e => {
    //   sessionStorage.setItem(
    //     "tabsItem",
    //     window.JSON.stringify({
    //       currTabsItem: this.tabsItem.filter(item => item.name !== "1"),
    //       currTabsPath: this.tabsPath.filter(item => item.name !== "1"),
    //       currActiveTabs: this.activeTab,
    //       currIndex: this.tabIndex
    //     })
    //   );
    // });
  },
  created() {
    Vue.prototype.$main = this;
    /*
     * 使用js的sessionStorage读取刷新前的数据，并按刷新前的tabs顺序重新生成tabs
     * */
    // const sessionTabs = JSON.parse(sessionStorage.getItem("tabsItem"));
    // if (
    //   sessionTabs != null &&
    //   sessionTabs.currTabsItem.length != 0 &&
    //   sessionTabs.currTabsPath.length != 0
    // ) {
    //   for (let i = 0; i < sessionTabs.currTabsItem.length; i++) {
    //     this.tabsItem.push({
    //       title: sessionTabs.currTabsItem[i].title,
    //       name: sessionTabs.currTabsItem[i].name,
    //       closable: true,
    //       ref: sessionTabs.currTabsItem[i].ref,
    //       content: sessionTabs.currTabsItem[i].content
    //     });
    //   }
    //   for (let j = 0; j < sessionTabs.currTabsPath.length; j++) {
    //     this.tabsPath.push({
    //       name: sessionTabs.currTabsPath[j].name,
    //       path: sessionTabs.currTabsPath[j].path
    //     });
    //   }
    //   this.activeTab = sessionTabs.currActiveTabs;
    //   this.tabIndex = sessionTabs.currIndex;
    //   //避免强制修改url 出现浏览器的url输入框的路径和当前tabs选中的路由路径不匹配
    //   const activePath = this.tabsPath.filter(
    //     item => item.name == this.activeTab
    //   );
    //   this.$router.push({
    //     path: activePath[0].path
    //   });
    // }
  },
  components: {
    deviceApartmentList,
    deviceApartmentDetail,
  }
};
</script>


// WEBPACK FOOTER //
// src/components/device/deviceApartmentTabs.vue